export const submitToUpload = async ({ props, fileList, afterUpload }) => {
    let file = fileList;
    let base64Url = await getBase64(file[0].originFileObj)
    props.getPreSignedUrlForImage(
        {
            currentTab: "wizardEditSurvey",
            fileName: file[0].name,
            fileType: file[0].type,
            isLogoUpload: true
        },
        (response) => {
            let imageData = response && response.data && response.data.data && response.data.data
            props.uploadImage(
                {
                    url: response ? response.data.data.preSignedUrl : "",
                    file: file[0],
                    fileType: file[0].type,
                    base64Url: base64Url
                },
                (isSuccess, response) => {
                    if (isSuccess) {
                        afterUpload(true, imageData)
                    } else {
                        afterUpload(false, imageData)
                    }
                }
            );
        }
    );
};


const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });